module.exports = __webpack_public_path__ + "img/rsz_afcfta_visions_2.27e64553.png";